import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { PortalRequestOtp } from './PortalRequestOtp';
import { PortalVerifyOtp } from './PortalVerifyOtp';
import { PortalDashboard } from './PortalDashboard';
import { accessPortalAsPassenger } from '@/api/portal';
const STORAGE_KEY = 'gv-portal-session';
const ADMIN_BYPASS_KEY = 'gv-portal-admin-bypass';
function loadSession() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const session = JSON.parse(raw);
        if (Date.now() > session.exp) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        // Validate session integrity — discard corrupted/incomplete sessions
        if (!session.portal?.passengerId || !session.token) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return session;
    }
    catch {
        return null;
    }
}
async function tryAdminBypass() {
    try {
        const raw = localStorage.getItem(ADMIN_BYPASS_KEY);
        if (!raw)
            return null;
        const { tenantSlug, passengerId, accessToken } = JSON.parse(raw);
        localStorage.removeItem(ADMIN_BYPASS_KEY);
        const { token, portal } = await accessPortalAsPassenger(tenantSlug, passengerId, accessToken);
        const session = { token, portal, exp: Date.now() + 86400000 };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
        return session;
    }
    catch {
        return null;
    }
}
export function PortalPage() {
    const [step, setStep] = useState('email');
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [portalData, setPortalData] = useState(null);
    // Extract tenant slug from URL: /portal/:tenantSlug or ?tenant=:tenantSlug
    const tenantSlug = (() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('tenant') ?? window.location.pathname.split('/portal/')[1] ?? 'demo';
    })();
    useEffect(() => {
        ;
        (async () => {
            const session = loadSession();
            if (session) {
                setToken(session.token);
                setPortalData(session.portal);
                setStep('dashboard');
                return;
            }
            const bypass = await tryAdminBypass();
            if (bypass) {
                setToken(bypass.token);
                setPortalData(bypass.portal);
                setStep('dashboard');
            }
        })();
    }, []);
    const handleEmailSubmitted = (submittedEmail) => {
        setEmail(submittedEmail);
        setStep('otp');
    };
    const handleOtpVerified = (newToken, newData) => {
        const session = {
            token: newToken,
            portal: newData,
            exp: Date.now() + 86400000,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
        setToken(newToken);
        setPortalData(newData);
        setStep('dashboard');
    };
    const handleLogout = () => {
        localStorage.removeItem(STORAGE_KEY);
        setToken('');
        setPortalData(null);
        setEmail('');
        setStep('email');
    };
    return (_jsxs("div", { className: "min-h-screen", style: { backgroundColor: step === 'dashboard' ? undefined : '#f1f5f9' }, children: [step !== 'dashboard' && (_jsx("div", { className: "min-h-screen flex items-center justify-center p-4", style: { backgroundColor: '#f1f5f9' }, children: _jsxs("div", { className: "w-full max-w-md", children: [step === 'email' && (_jsx(PortalRequestOtp, { tenantSlug: tenantSlug, onEmailSubmitted: (em) => handleEmailSubmitted(em) })), step === 'otp' && (_jsx(PortalVerifyOtp, { tenantSlug: tenantSlug, email: email, onBack: () => setStep('email'), onVerified: handleOtpVerified }))] }) })), step === 'dashboard' && portalData && (_jsx(PortalDashboard, { data: portalData, onLogout: handleLogout, token: token, tenantSlug: tenantSlug })), step === 'dashboard' && !portalData && (
            // portalData missing despite dashboard step — reset to OTP form
            _jsx("div", { className: "min-h-screen flex items-center justify-center p-4", style: { backgroundColor: '#f1f5f9' }, children: _jsx("div", { className: "w-full max-w-md", children: _jsx(PortalRequestOtp, { tenantSlug: tenantSlug, onEmailSubmitted: (em) => handleEmailSubmitted(em) }) }) }))] }));
}
//# sourceMappingURL=PortalPage.js.map